import { ELIGIBILITY_CRITERIA_FOR_TEACHERS_CARD_DATA } from '@lib/data/teacher-lp'
import Card from '@components/teacher-lp/card'

const IMAGE_PATH = '/images/teacher-lp/eligibility-criteria/'

type Props = {
  handleBecomeTeacher: () => void
}

const EligibilityCriteria = ({ handleBecomeTeacher }: Props) => (
  <>
    <div
      className="container mx-auto relative mt-20 md:mt-24"
      id="eligibility-criteria"
    >
      <Card
        data={ELIGIBILITY_CRITERIA_FOR_TEACHERS_CARD_DATA}
        heading="Eligibility criteria for teachers"
        imagePath={IMAGE_PATH}
        iconAlignment="items-baseline"
        titleAlignment="text-left"
        descriptionAlignment="text-left"
      />
    </div>
    <div className="md:flex md:justify-center pt-8 md:pt-10 px-4 md:px-0">
      <button
        onClick={handleBecomeTeacher}
        className="btn btn-orange py-3 md:text-xl text-2xl text-center md:text-left font-600 w-full md:w-auto"
      >
        Become a teacher
      </button>
    </div>
  </>
)

export default EligibilityCriteria
